/**
 * This code was AUTOGENERATED using the codama library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun codama to update it.
 *
 * @see https://github.com/codama-idl/codama
 */

import {
  combineCodec,
  getDiscriminatedUnionDecoder,
  getDiscriminatedUnionEncoder,
  getStructDecoder,
  getStructEncoder,
  getTupleDecoder,
  getTupleEncoder,
  getU8Decoder,
  getU8Encoder,
  type Codec,
  type Decoder,
  type Encoder,
  type GetDiscriminatedUnionVariant,
  type GetDiscriminatedUnionVariantContent,
} from '@solana/kit';
import {
  getEquatableOperatorDecoder,
  getEquatableOperatorEncoder,
  getIntegerOperatorDecoder,
  getIntegerOperatorEncoder,
  getMetaAssertionDecoder,
  getMetaAssertionEncoder,
  getStakeAssertionDecoder,
  getStakeAssertionEncoder,
  getStakeStateTypeDecoder,
  getStakeStateTypeEncoder,
  type EquatableOperator,
  type EquatableOperatorArgs,
  type IntegerOperator,
  type IntegerOperatorArgs,
  type MetaAssertion,
  type MetaAssertionArgs,
  type StakeAssertion,
  type StakeAssertionArgs,
  type StakeStateType,
  type StakeStateTypeArgs,
} from '.';

export type StakeAccountAssertion =
  | { __kind: 'State'; value: StakeStateType; operator: EquatableOperator }
  | { __kind: 'MetaAssertion'; fields: readonly [MetaAssertion] }
  | { __kind: 'StakeAssertion'; fields: readonly [StakeAssertion] }
  | { __kind: 'StakeFlags'; value: number; operator: IntegerOperator };

export type StakeAccountAssertionArgs =
  | {
      __kind: 'State';
      value: StakeStateTypeArgs;
      operator: EquatableOperatorArgs;
    }
  | { __kind: 'MetaAssertion'; fields: readonly [MetaAssertionArgs] }
  | { __kind: 'StakeAssertion'; fields: readonly [StakeAssertionArgs] }
  | { __kind: 'StakeFlags'; value: number; operator: IntegerOperatorArgs };

export function getStakeAccountAssertionEncoder(): Encoder<StakeAccountAssertionArgs> {
  return getDiscriminatedUnionEncoder([
    [
      'State',
      getStructEncoder([
        ['value', getStakeStateTypeEncoder()],
        ['operator', getEquatableOperatorEncoder()],
      ]),
    ],
    [
      'MetaAssertion',
      getStructEncoder([
        ['fields', getTupleEncoder([getMetaAssertionEncoder()])],
      ]),
    ],
    [
      'StakeAssertion',
      getStructEncoder([
        ['fields', getTupleEncoder([getStakeAssertionEncoder()])],
      ]),
    ],
    [
      'StakeFlags',
      getStructEncoder([
        ['value', getU8Encoder()],
        ['operator', getIntegerOperatorEncoder()],
      ]),
    ],
  ]);
}

export function getStakeAccountAssertionDecoder(): Decoder<StakeAccountAssertion> {
  return getDiscriminatedUnionDecoder([
    [
      'State',
      getStructDecoder([
        ['value', getStakeStateTypeDecoder()],
        ['operator', getEquatableOperatorDecoder()],
      ]),
    ],
    [
      'MetaAssertion',
      getStructDecoder([
        ['fields', getTupleDecoder([getMetaAssertionDecoder()])],
      ]),
    ],
    [
      'StakeAssertion',
      getStructDecoder([
        ['fields', getTupleDecoder([getStakeAssertionDecoder()])],
      ]),
    ],
    [
      'StakeFlags',
      getStructDecoder([
        ['value', getU8Decoder()],
        ['operator', getIntegerOperatorDecoder()],
      ]),
    ],
  ]);
}

export function getStakeAccountAssertionCodec(): Codec<
  StakeAccountAssertionArgs,
  StakeAccountAssertion
> {
  return combineCodec(
    getStakeAccountAssertionEncoder(),
    getStakeAccountAssertionDecoder()
  );
}

// Data Enum Helpers.
export function stakeAccountAssertion(
  kind: 'State',
  data: GetDiscriminatedUnionVariantContent<
    StakeAccountAssertionArgs,
    '__kind',
    'State'
  >
): GetDiscriminatedUnionVariant<StakeAccountAssertionArgs, '__kind', 'State'>;
export function stakeAccountAssertion(
  kind: 'MetaAssertion',
  data: GetDiscriminatedUnionVariantContent<
    StakeAccountAssertionArgs,
    '__kind',
    'MetaAssertion'
  >['fields']
): GetDiscriminatedUnionVariant<
  StakeAccountAssertionArgs,
  '__kind',
  'MetaAssertion'
>;
export function stakeAccountAssertion(
  kind: 'StakeAssertion',
  data: GetDiscriminatedUnionVariantContent<
    StakeAccountAssertionArgs,
    '__kind',
    'StakeAssertion'
  >['fields']
): GetDiscriminatedUnionVariant<
  StakeAccountAssertionArgs,
  '__kind',
  'StakeAssertion'
>;
export function stakeAccountAssertion(
  kind: 'StakeFlags',
  data: GetDiscriminatedUnionVariantContent<
    StakeAccountAssertionArgs,
    '__kind',
    'StakeFlags'
  >
): GetDiscriminatedUnionVariant<
  StakeAccountAssertionArgs,
  '__kind',
  'StakeFlags'
>;
export function stakeAccountAssertion<
  K extends StakeAccountAssertionArgs['__kind'],
  Data,
>(kind: K, data?: Data) {
  return Array.isArray(data)
    ? { __kind: kind, fields: data }
    : { __kind: kind, ...(data ?? {}) };
}

export function isStakeAccountAssertion<
  K extends StakeAccountAssertion['__kind'],
>(
  kind: K,
  value: StakeAccountAssertion
): value is StakeAccountAssertion & { __kind: K } {
  return value.__kind === kind;
}
